/**
 * 점검 관련 GraphQL 쿼리 및 뮤테이션
 */

import { gql } from "@apollo/client";
import { MachineInfoField, type MachineInfoPatch } from "@ict/shared/constants";

// @ict/shared에서 re-export (DRY 원칙)
export { MachineInfoField, type MachineInfoPatch };

// equipment.ts에서 MACHINE_DOCUMENT_QUERY re-export
export { MACHINE_DOCUMENT_QUERY } from "./equipment";

/**
 * 설비 문서 항목 일괄 수정 (웹과 동일한 API 사용)
 */
export const UPDATE_MACHINE_DOCUMENT_ITEMS_MUTATION = gql`
  mutation UpdateMachineDocumentItems($input: UpdateMachineDocumentItemsInput!) {
    updateMachineDocumentItems(input: $input) {
      success
      error
      errorCode
      machineDocument {
        id
        checkList {
          id
          title
          result
          image
          imageO
          imageX
          underReason
          underSolution
          group
        }
        maintenance {
          id
          title
          result
          image
          imageO
          imageX
          underReason
          underSolution
          group
        }
      }
      newVersion
      clientMutationId
    }
  }
`;

/**
 * 설비 정보 수정 (Feature 113: 모바일 요약 탭 UI)
 * 웹(@ict/web)과 동일한 mutation 사용
 */
export const UPDATE_MACHINE_INFO_MUTATION = gql`
  mutation UpdateMachineInfo($input: UpdateMachineInfoInput!) {
    updateMachineInfo(input: $input) {
      success
      error
      errorCode
      newVersion
      clientMutationId
      machineDocument {
        id
        title
        position
        modelNo
        modelYear
        modelCreator
        checkName
        checkStartDate
        checkEndDate
        version
      }
    }
  }
`;
